var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bootstrap-canvas"},[_c('div',{staticClass:"container-fluid"},[_c('content-block-constructor',{attrs:{"content-id":_vm.dataSource.model.contentId,"component-data-source":_vm.dataSource,"can-edit":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }